exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".check-image[data-v-7794b6c5] {\n  max-width: 50px;\n}\n", ""]);

// exports
